export const Step3 = ({
  packageWeight,
  setPackageWeight,
  handlePreviousStep,
  handleNextStep,
}) => {
  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold">
        Step 3: Empty and Weigh Package Contents
      </h2>
      <label className="block">
        Contents Weight (kg):
        <input
          type="number"
          value={packageWeight}
          onChange={(e) => setPackageWeight(e.target.value)}
          className="mt-1 block w-full p-2 border rounded"
        />
      </label>
      <div className="space-x-4">
        <button
          onClick={handlePreviousStep}
          className="bg-gray-500 hover:bg-gray-700 font-bold py-2 px-4 rounded"
        >
          Previous
        </button>
        <button
          onClick={handleNextStep}
          className="bg-green text-white hover:bg-green-700 font-bold py-2 px-4 rounded"
        >
          Next
        </button>
      </div>
    </div>
  );
};
